module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>'+
((__t=( vote_date.toLocaleDateString("en-US", {"dateStyle":"medium"}) ))==null?'':__t)+
'</td>\n<td>'+
((__t=( caption ))==null?'':__t)+
' ('+
((__t=( branch ))==null?'':__t)+
')</td>\n<td>'+
((__t=( yeas ))==null?'':__t)+
'</td>\n<td>'+
((__t=( nays ))==null?'':__t)+
'</td>\n<td>'+
((__t=( not_voting ))==null?'':__t)+
'</td>\n<td>'+
((__t=( excused ))==null?'':__t)+
'</td>\n';
}
return __p;
};
